<div class="container-confirmation">
  <p class="ion-text-center">
    {{confirmationText}}
  </p>
  <div class="buttons-content">
    <ion-button color="light" expand="block" (click)="closeModal(false)">Cancelar</ion-button>
    <ion-button expand="block" color="secondary" (click)="closeModal(true)">Aceptar</ion-button>
  </div>
</div>
